import React from 'react';
import { WebViewBridgeProvider, } from '@fourthwall/webview-bridge';
export const WebViewProvider = ({ children }) => {
    const handlers = {
        ios: {
            async openMobilePage(params) {
                window.webkit.messageHandlers.openMobilePage.postMessage(params);
            },
            async showInfoBanner(message) {
                window.webkit.messageHandlers.showInfoBanner.postMessage(message);
            },
        },
        android: {
            async openMobilePage(params) {
                const stringifiedParams = JSON.stringify(params);
                window.CreatorDashboardHandler.openMobilePage(stringifiedParams);
            },
            async showInfoBanner(message) {
                window.CreatorDashboardHandler.showInfoBanner(message);
            },
        },
    };
    return (React.createElement(WebViewBridgeProvider, { userAgent: window.navigator.userAgent, handlers: handlers }, children));
};
